module.exports = __webpack_public_path__ + "img/image.5627da52.svg";